import React from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
// import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// import InstagramIcon from '@material-ui/icons/Instagram';


import Logo from '../../../../components/Logo';

import useStyles from './styles';

const Footer: React.FC<{}> = () => {
  const classes = useStyles();

  const [isHiddenCNPJ, setIsHiddenCNPJ] = React.useState(true);

  const handleClickCNPJ: React.MouseEventHandler = () => {
    setIsHiddenCNPJ(!isHiddenCNPJ);
  };

  const renderCNJP = () => {
    return isHiddenCNPJ
      ? <span
        onClick={ handleClickCNPJ }
        className={ classes.hiddenCNPJ }></span>
      : <span onClick={ handleClickCNPJ }>30.063.822/0001-82</span>;
  };

  return (
    <footer className={ classes.root }>
      <Container>
        <Box className={ classes.mainInfo }>
          <Box>
            <Logo className={ classes.logo } alternative/>
            <Typography>CNPJ:&nbsp;{ renderCNJP() }</Typography>
            <Typography>
                Rua Mello Moraes Filho,
                195,
                Fazenda Grande do Retiro
            </Typography>
            <Typography>CEP: 40352-000</Typography>
            <Typography >Tel.: 0800 900 1010</Typography>
          </Box>
        </Box>
        <Divider className={ classes.separator } />
        <Box className={ classes.metaInfo }>
          <Typography>
            &copy; FullPC Telecom 2021 - Todos os direitos reservados
          </Typography>
        </Box>
      </Container>
    </footer>
  );
};

export default Footer;